export enum ERROR_CODE {
  INVALID_PASSWORD_FORMAT = 1001, //패스워드 형식 불일치(실서비스에서는 발생하지 않아야 할 에러)
  INVALID_LOGIN_ID_OR_PASSWORD = 1002, //인증실패, 아이디 또는 패스워드 틀림.
  INVALID_PARAMETER = 1003, //요청 파라미터가 잘못됨.
  INVALID_USER_ID = 1004, //userId가 잘못됨.
  INVALID_CHAT_ID = 1005, //chatId가 잘못됨.
  INVALID_CHAT_LOG_ID = 1006, //chatLogId가 잘못됨.
  INVALID_CALL = 1014, //이미 응답한 사람이 있거나, 종료된 통역.
  INVALID_PARTNER_ID = 1015, //partnerId가 잘못됨.
  INVALID_CODE = 1016, //code(QR)가 잘못됨.
  INVALID_FORMAT = 1017, //파라미터의 형식이 잘못됨(userId, name의 length 제한 등)
  INVALID_MEMO_ID = 1020, //memoId가 잘못됨.
  ALREADY_EXISTS_USER_ID = 1018, //이미 존재하는 userId
  ALREADY_EXISTS_QRCODE = 1021, //이미 동일한 이름의 QR코드가 존재
  VOICE_IS_TOO_SHORT = 1021, //녹음된 음성의 길이가 짧습니다.
  WS_CONNECTION_TIMEOUT = 1022, //웹소켓 연결 타임아웃
  OFF_FAIRCON_CALL = 1023, //통역에서 호스트가 없을 경우 유저가 접속시도할 때
  INTERNAL_CONTRACT_DUPLICATED = 1024, //기간내에 중복되는 계약이 이미 존재합니다
  BAD_REQUEST = 4000,
  UNAUTHORIZATION = 4010,
  FORBIDDEN = 4030,
  UNKNOWN = 5000,
  SERVER_AUTHORIZATION_KEY_ERROR = 5001,
  UNEXECUTABLE = 5010,
}

export enum QrAccessType {
  NORMAL = 'NORMAL',
  DEMO = 'DEMO', // 데모
  TEST = 'TEST', // 내부테스트
}

export const isQrAccessType = {
  isNormal: (type: QrAccessType): boolean => type === QrAccessType.NORMAL,
  isDemo: (type: QrAccessType): boolean => type === QrAccessType.DEMO,
  isTest: (type: QrAccessType): boolean => type === QrAccessType.TEST,
};

export enum SocketState {
  CONNECTING = 'CONNECTING',
  OPEN = 'OPEN',
  ERROR_NO_HEADER = 'ERROR_NO_HEADER',
  CLOSED = 'CLOSED',
  RETRY_FAILED = 'RETRY_FAILED',
}

export enum ReadyState {
  CONNECTING = 0,
  OPEN = 1,
  CLOSING = 2,
  CLOSED = 3,
}

export const CARD_COMPANY_CODE = {
  '46': '광주은행',
  '11': 'KB국민카드',
  '91': 'NH농협카드',
  '71': '롯데카드',
  '30': 'KDB산업은행',
  '51': '삼성카드',
  '38': '새마을금고',
  '34': 'Sh수협은행',
  '41': '신한카드',
  '62': '신협',
  '36': '씨티카드',
  '33': '우리카드',
  W1: '우리카드',
  '37': '우체국예금보험',
  '39': '저축은행중앙회',
  '35': '전북은행',
  '42': '제주은행',
  '15': '카카오뱅크',
  '3A': '케이뱅크',
  '24': '토스뱅크',
  '21': '하나카드',
  '61': '현대카드',
  '31': '비씨카드',
  '6D': '다이너스 클럽',
  '6I': '디스커버',
  '4M': '마스터카드',
  '3C': '유니온페이',
  '4J': 'JCB',
  '4V': 'VISA',
  '3K': '기업비씨',
  '7A': '아메리칸 익스프레스F',
  KBS: 'KB증권',
  PCP: '페이코포인트',
  NIC: '나이스페이먼츠',
  KON: '코나',
};
